import LazyMarketMain from './LazyMarketMain';

export default LazyMarketMain;
